<script lang="ts">
	import type { Menu, Category } from "../../../functions/place/types";
	import { formatKrwNumber } from "../../utils";

	export let categories: Category[] = [];

	$: selectedCategory = categories.filter(hasVisibleMenu)[0];
	$: selectedMenus = selectedCategory ? selectedCategory.menus : [];

	const hasVisibleMenu = (category: Category) => {
		if (category.menus.length === 0) return false;
		const visibleMenus = category.menus.filter((v) => v.show);
		return visibleMenus.length > 0;
	};

</script>

<div class="container" t-id="menu viewer">
	<div class="categories">
		{#each categories.filter(hasVisibleMenu) as category}
			<div
				class="category-name"
				class:selected={category === selectedCategory}
				on:click={() => (selectedCategory = category)}>
				{category.name}
			</div>
		{/each}
	</div>
	<div class="menus">
		{#each selectedMenus.filter((v) => v.show) as menu}
			<div class="menu-container">
				<div class="name-price">
					<div class="name">{menu.name}</div>
					<div class="price">{formatKrwNumber(menu.price)}원</div>
				</div>
				{#if menu.desc && menu.desc.trim()}
					<div class="desc">{menu.desc}</div>
				{/if}
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		display: flex;
		gap: 10px;
		width: 100%;
		color: #46474b;
		font-weight: 500;

		.categories {
			display: flex;
			flex-direction: column;
			gap: 10px;
			width: 68px;

			.category-name {
				word-break: break-all;
				&:hover {
					cursor: pointer;
				}
				&.selected {
					color: #3c68d6;
				}
			}
		}

		.menus {
			flex-grow: 1;
			display: flex;
			flex-direction: column;

			.menu-container {
				width: 100%;
				display: flex;
				flex-direction: column;
				gap: 6px;
				border-bottom: 1px solid #d8d9df;
				padding-top: 10px;
				padding-bottom: 10px;
				&:first-child {
					padding-top: 0;
				}
				.name-price {
					display: flex;
					width: 100%;
					word-break: break-all;
					.name {
						max-width: 70%;
						width: 70%;
					}
					.price {
						max-width: 30%;
						width: 30%;
						font-weight: 200;
						text-align: right;
					}
				}
				.desc {
					color: #6d6f76;
					font-size: 0.875rem;
					font-weight: 200;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			.categories {
				font-size: 1.25rem;
				width: 105px;
				gap: 20px;
			}
			.menus {
				.menu-container {
					gap: 10px;
					.name-price {
						font-size: 1.25rem;
					}
					.desc {
						font-size: 1.125rem;
					}
				}
			}
		}
	}

</style>
